import { render, staticRenderFns } from "./distributionApplicationRecord.vue?vue&type=template&id=c56bca50&scoped=true"
import script from "./distributionApplicationRecord.vue?vue&type=script&lang=js"
export * from "./distributionApplicationRecord.vue?vue&type=script&lang=js"
import style0 from "./distributionApplicationRecord.vue?vue&type=style&index=0&id=c56bca50&prod&lang=less&scoped=true"
import style1 from "./distributionApplicationRecord.vue?vue&type=style&index=1&id=c56bca50&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56bca50",
  null
  
)

export default component.exports